<template>
  <div class="form-detail">
    <el-table :data="tableDataOk" border style="width: 100%">
      <el-table-column label="备案号" width="180" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.recordCode }}</span>
        </template>
      </el-table-column>
      <el-table-column label="预案类型" >
        <template slot-scope="scope">
          <span v-if="scope.row.processKey=='HeavyPollWeather'">重污染天气应急预案</span>
          <span v-if="scope.row.processKey=='SuddenEnvEvent'">突发环境事件应急预案</span>
        </template>
      </el-table-column>
      <el-table-column label="申报单位名称">
        <template slot-scope="scope">
          <span>{{ scope.row.subjectName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建日期" width="120">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.createDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请日期" width="120">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.startDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请人" >
        <template slot-scope="scope">
          <span>{{ scope.row.creatorName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备案完成日期" >
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.completeDate)  }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备案生效日期" >
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.effectiveDate)  }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备案有效日期" >
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.expireDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <button class="btnTheme" type="text" size="small" @click="handle(scope.row)">备案进度</button>
          <button class="btnTheme" type="text" size="small" @click="handleInfo(scope.row)">备案信息</button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import moment from 'moment'
import weather from '../../data/emer/weather.js'
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      tableDataOk: [],
      subjectId: '',
      num:0
    }
  },
  created() {
    if (sessionStorage.itemName) {
      this.subjectId = JSON.parse(sessionStorage.itemName).id
      this.getDataNo({
        subjectId: this.subjectId,
        processKey: 'HeavyPollWeather'
      })
    } else {
      this.message.warning('请求超时,请重试！！！')
    }
  },
  methods: {
    getDataNo(params) {
      this.num = 0;
      this.tableDataOk = [];
      (async() => {
        let getState = await weather.process_complete(params)
        if (getState.status) {
          this.tableDataOk = getState.data.content
          this.num += getState.data.totalElements;
          this.$emit('setNum')
        } else {
          this.$message.error(getState.msg)
        }
      })()
    },
    formatTime(time) {
      if (!time) return ''
      return moment(time).format('YYYY/MM/DD')
    },
    // 备案进度
    handle(val) {
      sessionStorage.planIdLists = val.planId
      this.$router.push({
        name: "FillingProgress",
        path: "/Filedwed/filing",
        query: {
          planId: val.planId,
          instanceId: val.instanceId,
          processKey: val.processKey
        }
      });
    },
    // 备案信息
    handleInfo(val) {
      sessionStorage.planIdLists = val.planId
      this.$router.push('/FillingInfo')
    },
  }

}

</script>
<style lang="stylus" scoped>
.btnTheme {
  display: inline-block;
  margin-left: 0;
  font-size: 12px;
  border: none;
  color: #20a0ff;
  background: 0 0;
  padding-left: 0;
  padding-right: 0;
  outline: none;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// recordend.vue?4aa1e985